<div class="main-ag-grid-container flex-column">
    <mat-card class="h-100">
        <!-- Toolbar -->
        <div class="grid-toolbar">
            <!-- Grid Header -->
            <div class="grid-title">
                <h3>Recommended Buy Quantity</h3>
            </div>
            <div *ngIf="assortmentPlanName" class="plan-info-container">
                <div class="plan-info">
                    <span>{{ assortmentPlanName }}</span>
                    <span> | </span>
                    <span>{{ buyingSeason }}</span>
                </div>
            </div>
            <div class="grid-tool-panel-btn-container">
                <div>
                    <button mat-button color="secondary" (click)="openRepositoryModal()">Plan Repository</button>
                    <button mat-button color="secondary" (click)="openUploadPlanModal()">Upload New Plan</button>
                    <button mat-button color="secondary" [disabled]="!assortmentPlanName" (click)="runBuyReco()">
                        Run Buy Reco
                    </button>
                </div>
                <!-- Search Filter -->
                <div class="prod-filter">
                    <mat-form-field>
                        <input matInput placeholder="Search plan..." (input)="onProdFilterChange($event)" />
                    </mat-form-field>
                </div>
                <!-- Rows Selected User Feedback -->
                <caption *ngIf="selectedRows.length > 0">
                    {{
                        selectedRows.length
                    }}
                    Row{{
                        selectedRows.length === 1 ? '' : 's'
                    }}
                    Selected
                </caption>
                <!-- Save Plan -->
                <span>
                    <button
                        mat-raised-button
                        color="accent"
                        [disabled]="!assortmentPlanName"
                        class="primary-split-button"
                        (click)="savePlan($event)"
                    >
                        Save Plan
                    </button>
                    <!-- More Options -->
                    <button
                        id="split-button"
                        mat-raised-button
                        color="accent"
                        [matMenuTriggerFor]="moreOptions"
                        #tooltip="matTooltip"
                        matTooltip="More Options"
                        matTooltipClass="below"
                    >
                        <mat-icon aria-hidden="false" aria-label="More Options" class="m-0">menu_open</mat-icon>
                    </button>
                </span>
                <mat-menu #moreOptions="matMenu">
                    <!-- Approve Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onApprove($event)"
                        [disabled]="loading || !gridActionsEnabled.approve"
                    >
                        Approve Selected
                    </button>
                    <!-- Reject Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onReject($event)"
                        [disabled]="loading || !gridActionsEnabled.reject"
                    >
                        Reject Selected
                    </button>
                    <!-- Lock Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onLock($event)"
                        [disabled]="loading || !gridActionsEnabled.lock"
                    >
                        Lock Selected
                    </button>
                    <!-- Unlock Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onUnlock($event)"
                        [disabled]="loading || !gridActionsEnabled.unlock"
                    >
                        Unlock Selected
                    </button>
                    <!-- Reset Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onReset()"
                        [disabled]="loading || !gridActionsEnabled.reset"
                    >
                        Discard Selected Edits
                    </button>
                    <!-- Submit Selected button -->
                    <button
                        class="menu-panel-accent-btn"
                        mat-menu-item
                        color="accent"
                        (click)="onSubmit()"
                        [disabled]="loading || !gridActionsEnabled.submit"
                    >
                        Submit Selected to Review Orders
                    </button>
                </mat-menu>
            </div>
        </div>
        <!-- AG Grid -->
        <ag-grid-angular
            id="reco-buy-qty-grid"
            class="ag-theme-alpine ag-grid-container"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            [loading]="loading"
            [statusBar]="statusBar"
        >
        </ag-grid-angular>
        <!-- <mat-drawer-container autosize>
            <mat-drawer #drawer mode="side" position="end" from="right" (keydown.escape)="drawer.close()">
            <div class="repo-header">
                <span>Repository</span>
                <button mat-button (click)="drawer.close()">Close</button>
            </div>
            <div class="repo-filters">
                <mat-form-field>
                    <input matInput placeholder="Search by name/season/user"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-select>
                        <mat-option>All</mat-option>
                        <mat-option>Draft</mat-option>
                        <mat-option>Submitted</mat-option>
                        <mat-option>Approved</mat-option>
                        <mat-option>Rejected</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="repo-grid">
                <ag-grid-angular
                    id="reco-buy-qty-repo-grid"
                    class="ag-theme-alpine ag-grid-container"
                    [columnDefs]="repoColumnDefs"
                    [rowData]="repoRowData"
                    [gridOptions]="repoGridOptions"
                    (gridReady)="onRepoGridReady($event)"
                ></ag-grid-angular>
            </div>
            </mat-drawer>
        </mat-drawer-container> -->
    </mat-card>
</div>
